import { useEffect, useState } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import {
  SIDEBAR_DRAWER_WIDTH,
  SIDEBAR_DRAWER_WIDTH_COLLAPSED,
} from '../components/Sidebar';

function readSidebarOpen(): boolean {
  try {
    const saved = localStorage.getItem('sidebarOpen');
    return saved !== null ? saved === 'true' : true;
  } catch {
    return true;
  }
}

/**
 * Ancho ocupado por el sidebar en desktop (0 en mobile),
 * sincronizado con `sidebar-open-change` del Layout.
 */
export function useSidebarContentLeft(): number {
  const theme = useTheme();
  const isMdUp = useMediaQuery(theme.breakpoints.up('md'));
  const [sidebarOpen, setSidebarOpen] = useState(readSidebarOpen);

  useEffect(() => {
    const onChange = (event: Event) => {
      const custom = event as CustomEvent<{ open?: boolean }>;
      if (typeof custom.detail?.open === 'boolean') {
        setSidebarOpen(custom.detail.open);
        return;
      }
      setSidebarOpen(readSidebarOpen());
    };
    window.addEventListener('sidebar-open-change', onChange as EventListener);
    window.addEventListener('storage', onChange);
    return () => {
      window.removeEventListener('sidebar-open-change', onChange as EventListener);
      window.removeEventListener('storage', onChange);
    };
  }, []);

  if (!isMdUp) return 0;
  return sidebarOpen ? SIDEBAR_DRAWER_WIDTH : SIDEBAR_DRAWER_WIDTH_COLLAPSED;
}
